import { CategoryViewModel } from 'store/models/sellModels'
import Guid from 'utilities/Guid'

export const MENUSECTION_ALL_ITEMS = Guid.empty
export const ALL_ITEMS_CATEGORY_ID = Guid.empty
export const defaultAllCategory: () => CategoryViewModel = () => ({
    categoryId: ALL_ITEMS_CATEGORY_ID,
    name: 'All Items',
    sortNumber: -1,
})
